document.addEventListener("DOMContentLoaded", function () {
  if (typeof $ !== "undefined" && $('.hero-slider').length) {

    $('.hero-slider').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 300,
      fade: true,
      cssEase: 'ease-in-out',
      adaptiveHeight: true
    });

  }
});